import React from "react";

import LoaderSvg from "@components/icons/loader-svg";

function Spinner() {
  return <div />;
}

export default Spinner;
